import React from "react";

export const AppTheme = React.createContext("");

export const withAppTheme = Component => props => (
  <AppTheme.Consumer>{appTheme => <Component {...props} appTheme={appTheme} />}</AppTheme.Consumer>
);
